export class clickableColumns {
    column: string;                  // this will be the same name as in sendDisplayedColumns $$..
    icon: string;                    // icon should be valid icon name $$..
    function: string;                // target function will be called on click event $$..
}

